// actions/core.ts — M0
import { EMOTES, type EmoteId } from '@whiskerton/content';
import { defineAction, type Ok } from '../define';
import { g, MAX_TEXT } from '../guard';
import type { ChatLine } from '../../types/chat';
import type { MoveState, SpaceId, SpaceSnapshot } from '../../types/space';
import type { TownSettings } from '../../types/town';
declare module '../registry' {
  interface ActionMap {
    'space.enter': { req: { to: SpaceId }; res: { space: SpaceSnapshot; spawn: MoveState } };
    'chat.say': { req: { text: string }; res: { line: ChatLine } };
    'emote.play': { req: { emote: EmoteId }; res: Ok };
    'town.settings': { req: { patch: { residentsCanInvite?: boolean; instantMail?: boolean } }; res: { settings: TownSettings } };
  }
}
export const spaceEnter = defineAction('space.enter', g.obj({ to: g.space }));
export const chatSay = defineAction('chat.say', g.obj({ text: g.str(1, MAX_TEXT) }), 'chat');
export const emotePlay = defineAction('emote.play', g.obj({ emote: g.lit(...EMOTES) }));
export const townSettings = defineAction('town.settings',
  g.obj({ patch: g.obj({ residentsCanInvite: g.opt(g.bool), instantMail: g.opt(g.bool) }) }));
